import { Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, Validators } from '@angular/forms';
import { MatDatepicker } from '@angular/material/datepicker';
import moment from 'moment';
import { ReportService } from 'src/app/services/report.service';
import Swal from 'sweetalert2';

@Component({
    selector: 'app-installation-activation-report',
    templateUrl: './installation-activation-report.component.html',
    styleUrls: ['./installation-activation-report.component.scss']
})
export class InstallationActivationReportComponent implements OnInit {
    installationReportForm: any;
    toMinDate: Date;
    toMaxDate: Date;
    @ViewChild('startDate') startDateDatePicker: MatDatepicker<Date>;
    @ViewChild('endDate') endDateDatePicker: MatDatepicker<Date>;

    constructor(private fb: FormBuilder,private reportService:ReportService) { }


    ngOnInit(): void {
        this.init()
    }
    init() {
        this.installationReportForm = this.fb.group({
            startDate: [null,Validators.required],
            endDate: [null,Validators.required]
        });
    }

    Reset() {
        this.installationReportForm.reset()
    }
    openStartDateDatePicker() {
        this.startDateDatePicker.open();
    }

    openEndDateDatePicker() {
        this.endDateDatePicker.open();
        this.toMinDate = this.installationReportForm.controls["startDate"].value;
        // this.toMaxDate = this.addMonths(this.toMinDate, 3);
    }
    generateExcel () {

        if (!this.installationReportForm.value.startDate && !this.installationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date and To date should not be empty',
                position: 'center',

            })
        }
        else if (!this.installationReportForm.value.startDate) {
            Swal.fire({
                icon: 'warning',
                title: 'From date should not be empty',
                position: 'center',

            })
        }
        else if (!this.installationReportForm.value.endDate) {
            Swal.fire({
                icon: 'warning',
                title: 'End date should not be empty',
                position: 'center',

            })
        }
        else if (this.installationReportForm.value.startDate > this.installationReportForm.value.endDate) {
         if (this.installationReportForm.value.endDate) {

                Swal.fire({
                    icon: 'warning',
                    title: 'End Date should be greater than Start Date',
                    position: 'center',

                })
            }
        }
        else {
            var filterSearch = {};
            var start = moment(this.installationReportForm.value.startDate._d).format("YYYY/MM/DD");
            var end = moment(this.installationReportForm.value.endDate._d).format("YYYY/MM/DD");
            filterSearch = { startDate: start, endDate: end};


            this.reportService.getActivationReport(this.installationReportForm.value).subscribe( (data)=> {
                debugger
                if (data) {
                    debugger
                    const linkSource = 'data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64, ' + data;
                    const downloadLink = document.createElement('a');
                    const fileName = 'HC Activation & Installation Report.xls';
                    downloadLink.href = linkSource;
                    downloadLink.download = fileName;
                    downloadLink.click();
                }
            });
        }
    }

}
